import { gql } from "@apollo/client";

export const GET_USERS = gql`
  query getUsers($args: SearchUsersArgs!) {
    users(args: $args) {
      items {
        id
        username
        name
        password
        role
        imageURL
        establishment {
          name
        }

        status
        createdAt
      }
      meta {
        page
        count
        to
        total
        lastPage
      }
    }
  }
`;
